import Iconfont from '@utils/Iconfont'
import styles from '../../../index.module.scss'

const SmartDetailPageBatch = ({ record, recordRef, smartDetailPageComRef }) => {
    return (
        <div className={styles.smartConfigWrap}>
            <p onClick={() => {
                recordRef.current = record
                smartDetailPageComRef.current?.setColorOpen(true)
            }}>
                {
                    record?.commodityColor?.length > 0 ?
                        <>
                            <span className={styles.smartConfigWrapSpan}>
                                {record.commodityColor.slice(0, 2).map(item => item.title).join('、')}
                            </span>&nbsp;&nbsp;
                            {record.commodityColor?.length > 2 ? `等${record.commodityColor?.length - 2}个颜色` : ''}
                        </> :
                        <><Iconfont className={styles.icon} type="icon-commodityColorOutlined" />选择颜色</>
                }
            </p>
            <p onClick={() => {
                recordRef.current = record
                smartDetailPageComRef.current?.setCategoryOpen(true)
            }}>
                {
                    record?.commodityCategory?.title ?
                        <span className={styles.smartConfigWrapSpan}>{record.commodityCategory.title}</span> :
                        <><Iconfont className={styles.icon} type="icon-commodityCategoryOutlined" />选择类目</>
                }
            </p>
            <p onClick={() => {
                recordRef.current = record
                smartDetailPageComRef.current?.setTemplateOpen(true)
            }}>
                {
                    record?.commodityTemplate?.title ?
                        <span className={styles.smartConfigWrapSpan}>
                            {record.commodityTemplate.title?.split('-')[1] || record.commodityTemplate.title}
                        </span> :
                        <><Iconfont className={styles.icon} type="icon-commodityTemplateOutlined" />选择模板</>
                }
            </p>
        </div>
    )
}

export default SmartDetailPageBatch